import { useState, useEffect } from 'react';

import { getBrandThunk } from 'common/features/store/duck/brands/duck';
import { useDispatch } from 'react-redux';
import {
    processOnBonusBrands,
    ConstructorReturnObject,
    constructorToBrand,
} from 'common/api/constructor/util';
import { Brand } from 'common/features/store/duck/search-generic/utils/searchResultBrandsToBrands';
import { isAffiliateOnlyBrand } from 'common/utils/affiliate';
import { useRootSelector } from 'common/features/featuresReducer';
import { useConstructorDefaultParameters } from 'common/api/constructor/useConstructorDefaultParameters';
import ConstructorIO from '@constructor-io/constructorio-client-javascript';

export function isRaiseRightOnlyBrandWithoutAffiliate(brand?: Brand) {
    return brand?.isRaiseRightBrand && !brand?.containsAffiliateOffer;
}

export const useConstructorBrandById = (
    isConstructorEnabled?: boolean,
    constructorClient?: ConstructorIO,
    brandIdParam?: string | number
) => {
    const dispatch = useDispatch();
    const [constructorBrand, setConstructorBrand] = useState<Brand>();
    const [constructorBrandHasLoaded, setConstructorBrandHasLoaded] = useState(false);

    const brand = useRootSelector((state) => {
        if (brandIdParam) {
            return state.store.brands.brandsById[brandIdParam as number];
        }
    });

    const baseFilters = useConstructorDefaultParameters({ resultsPerPage: 1 });

    useEffect(() => {
        if (brandIdParam && !isAffiliateOnlyBrand(`${brandIdParam}`)) {
            const numbericBrandId =
                typeof brandIdParam === 'string' ? parseInt(brandIdParam) : brandIdParam;
            getBrandThunk(numbericBrandId)(dispatch).then((r) => {
                setConstructorBrandHasLoaded(true);
            });
        }
    }, [brandIdParam, baseFilters, dispatch, constructorClient?.browse, isConstructorEnabled]);

    useEffect(() => {
        if (brandIdParam && isConstructorEnabled) {
            constructorClient?.browse
                .getBrowseResultsForItemIds([`${brandIdParam}`], baseFilters.current)
                .then(({ response }) => {
                    const validBrands = processOnBonusBrands(
                        response?.results as ConstructorReturnObject[],
                        false
                    );
                    const brandConstructor = constructorToBrand(validBrands || [])[0] as Brand;

                    setConstructorBrand(brandConstructor);
                    setConstructorBrandHasLoaded(true);
                });
        }
    }, [brandIdParam, dispatch, isConstructorEnabled]);

    const isGiftCardOnlyBrand = isRaiseRightOnlyBrandWithoutAffiliate(constructorBrand);
    const isAffiliateOnlyBrand_ = isAffiliateOnlyBrand(`${brandIdParam}`);

    return {
        brand,
        constructorBrand,
        isAffiliateOnlyBrand: isAffiliateOnlyBrand_,
        isGiftCardOnlyBrand,
        constructorBrandHasLoaded: constructorBrandHasLoaded,
    };
};
